import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../../axiosAuth";
import { BOM_POSITION_API } from "../apiRoutes";

const mutateAddPosition = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(`${BOM_POSITION_API}`, data);
};

const useAddPositionMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddPosition,
    ...queryParams,
  });

export default useAddPositionMutation;
